import { Component, OnInit } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EcareSecurityService } from '../services/ecare_security_service';
declare var $: any;
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {first} from 'rxjs/operators';
import {UserService} from '../services/user.service';
import {ToastrService} from 'ngx-toastr';
import {UserServiceService} from '../user/user-service/user-service.service';
import { Location } from '@angular/common';
declare var DDP_ENV: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentPage: any = '';
  currentVersion = '';
  today = new Date();
  user: any;
  clientName: any;
    animal: string;
    name: string;
    userId: string;
    closeResult: string;
    resetForm: any;
    title = "";
    //pageTitle: any;
  constructor(public sidebarservice: SidebarService, private router: Router,
    private activatedRoute: ActivatedRoute, public securityService: EcareSecurityService,
              private modalService: NgbModal, private formBuilder: FormBuilder,
              private userService: UserServiceService, private toastr: ToastrService,
              private location: Location) {
     // this.getClientName();
     this.router.events.subscribe((event)  => {
        if (event instanceof NavigationEnd) {
            this.currentPage =  event.url.substr(1).toUpperCase();
            this.title = this.activatedRoute.snapshot.firstChild.data.title;
        }
        //this.pageTitle = location.path(false).toUpperCase().split('/')[2].split('?')[0].split(';')[0];
        /* if(location.path().startsWith('/dashboard')){
             //this.isNotOnDashboard = false;
             console.log();
         }else {
             //this.isNotOnDashboard = true;
             console.log();
         }*/
      });
     this.user = this.securityService.getUserDetails();

      this.resetForm = this.formBuilder.group({
          oldPassword: ['', Validators.required],
          newPassword: ['', Validators.required],
      });
  }


  ngOnInit() {
        this.currentVersion = this.securityService.getVersion();
  }

    getClientName(){
        if (localStorage.getItem('clientId') === 'ELASTIC_CARE') {
            this.clientName = 'ELASTIC CARE';
        }  else {
            const clientList = JSON.parse(localStorage.getItem('clientList'));
            for (let i = 0; i < clientList.length ; i++) {
                if (clientList[i].id === localStorage.getItem('clientId')) {
                    this.clientName = clientList[i].clientName;
                    break;
                }
            }
        }
    }

/*  toggleSidebar() {
    this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
  }
  toggleBackgroundImage() {
    this.sidebarservice.hasBackgroundImage = !this.sidebarservice.hasBackgroundImage;
  }
  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  hideSidebar() {
    this.sidebarservice.setSidebarState(true);
  }*/

    toggleDropDown() {
      if ($('#profileDowpDown').css('display') === 'none') {
          $('#profileDowpDown').css('display', 'block');
      } else {
          $('#profileDowpDown').css('display', 'none');
      }
    }

    viewProfile(){
        $('#profileDowpDown').css('display', 'none');
    }
    viewSettings(){
        $('#profileDowpDown').css('display', 'none');
    }

    logout() {
        this.securityService.logout();
        this.router.navigate(['/login']);
    }

    isAdmin(){
        this.userId = this.securityService.getUserDetails().id;
        if (this.userId === 'ADMIN') {
            return true;
        }else{
            return false;
        }
    }

    open(content) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

    changePassword() {
        console.log(JSON.stringify(this.resetForm.value));
       /* console.log(this.securityService.getUserDetails().id);
        console.log(this.securityService.getUserDetails());*/
        this.userId = this.securityService.getUserDetails().id;
        this.userService.changePassword(this.resetForm.value, this.userId)
            .pipe(first())
            .subscribe(data => {
                if (data.status === 200) {
                    this.toastr.success('', 'Password Changed Successfully');
                    this.modalService.dismissAll();
                    this.securityService.logout();
                } else {
                    this.toastr.error('', 'Please try again');
                }
            }, (error) => {
                this.toastr.error('', 'Please try again');
            });
    }
}
